export const Step = (
  e: React.KeyboardEvent<HTMLInputElement>,
  index: number,
  elm: string
) => {
  const target = e.target as HTMLInputElement;
  const value = target.value;

  if (e.key !== 'Backspace') {
    if (value.length === target.maxLength && index > 0) {
      document.getElementById(`${elm}${index - 1}`)?.focus();
    }
  } else {
    if (value.length === 0 && index < 3) {
      document.getElementById(`${elm}${index + 1}`)?.focus();
    }
  }

  // Enable all inputs
  const items = document.getElementsByClassName('step-input');
  for (let i = 0; i < items.length; i++) {
    (items[i] as HTMLInputElement).disabled = false;
  }
};